import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { articles } from "@/mocks/articles";

export default function CategoryStrip() {
  return (
    <section className="px-4 py-10 md:px-8 md:py-14">
      <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
        <div>
          <h2 className="font-heading text-xl font-black text-foreground-950 md:text-2xl">
            按主题找瓜
          </h2>
          <p className="mt-1.5 text-sm font-label text-foreground-500">
            五大主题分区，覆盖娱乐、社会、网红、影视与情感话题，点进去就是一条条整理好的事件线。
          </p>
        </div>
        <Link
          to="/hot"
          className="hidden items-center gap-1 text-sm font-label text-primary-700 transition-colors hover:text-primary-800 md:flex"
        >
          查看实时热度榜
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>

      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
          >
            <div className="relative h-28 w-full overflow-hidden bg-background-200">
              <img
                src={cat.cover}
                alt={`${cat.name}分类封面 - 52吃瓜网`}
                title={`${cat.name} 52吃瓜网`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 flex h-8 w-8 items-center justify-center rounded-md bg-background-50/90 text-base text-primary-600 backdrop-blur">
                <i className={cat.icon}></i>
              </span>
            </div>
            <div className="flex flex-1 flex-col p-4">
              <h3 className="font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
                {cat.name}
              </h3>
              <p className="mt-1 text-xs font-label text-foreground-500">{cat.tagline}</p>
              <span className="mt-3 flex items-center gap-1 text-xs font-label text-foreground-400">
                <i className="ri-file-list-3-line"></i>
                {articles.filter((item) => item.categorySlug === cat.slug).length} 条事件记录
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}